import React from 'react';
import { MaterialUICore } from '@iclinic/design-system';

import GlicIcon from './GlicIcons';

const { styled } = MaterialUICore;

const GlicBadgeContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '4px 8px',
  gap: '10px',
  width: 119,
  maxWidth: 224,
  height: 24,
  background: '#EEE2FD',
  mixBlendMode: 'normal',
  borderRadius: '4px',
  fontSize: '.75rem',
  color: '#732dd2',
  fontWeight: 500,
});

export default function GlicBadge() {
  return (
    <GlicBadgeContainer>
      <div style={{ marginTop: '5px' }}>
        <GlicIcon />
      </div>
      <div>Paciente Glic</div>
    </GlicBadgeContainer>
  );
}
